import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import TravelCategoryService from "../../services/category.service";

// **Async Thunks**
export const addtravelCategory = createAsyncThunk(
  "travelCategory/addtravelCategory",
  async (item, thunkAPI) => {
    try {
      const response = await TravelCategoryService.addtravelCategory(item);
      return response.data; // Return actual data
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const gettravelCategoryList = createAsyncThunk(
  "travelCategory/gettravelCategoryList",
  async (item, thunkApi) => {
    try {
      const response = await TravelCategoryService.gettravelCategoryList(item);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const edittravelCategory = createAsyncThunk(
  "travelCategory/edittravelCategory",
  async (item, thunkAPI) => {
    try {
      const response = await TravelCategoryService.edittravelCategory(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deletetravelCategory = createAsyncThunk(
  "travelCategory/deletetravelCategory",
  async (id, thunkAPI) => {
    try {
      await TravelCategoryService.deletetravelCategory(id);
      return id; // Return only the ID to remove it from state
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

// **Initial State**
const initialState = {
  loading: false,
  error: "",
  travelCategories: [],
};

// **Slice**
const travelCategorySlice = createSlice({
  name: "travelCategory",
  initialState,
  extraReducers: (builder) => {
    builder
      // **Handle Get Travel Category List**
      .addCase(gettravelCategoryList.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(gettravelCategoryList.fulfilled, (state, action) => {
        state.loading = false;
        state.travelCategories = action.payload;
      })
      .addCase(gettravelCategoryList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Add Travel Category**
      .addCase(addtravelCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(addtravelCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.travelCategories.push(action.payload);
      })
      .addCase(addtravelCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Edit Travel Category**
      .addCase(edittravelCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(edittravelCategory.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.travelCategories.findIndex((c) => c.id === action.payload.id);
        if (index !== -1) {
          state.travelCategories[index] = action.payload;
        }
      })
      .addCase(edittravelCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Delete Travel Category**
      .addCase(deletetravelCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletetravelCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.travelCategories = state.travelCategories.filter((c) => c.id !== action.payload);
      })
      .addCase(deletetravelCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// **Export Reducer**
export default travelCategorySlice.reducer;
